import axios from 'axios'
import { pathOr } from 'ramda'
import URLSearchParams from 'url-search-params'

import { IsDev } from 'js/helpers/build'
import { SEARCH_ENDPOINT } from 'js/helpers/request'
import {
  DESTINATIONS_PAGE_VIEW,
} from '../constants'
import openPopup from 'js/components/PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from 'js/components/PopupConstructor/constants'
import toggleGlobalLoader from 'js/components/loader/actions/loaderActions'
import { tid } from 'js/components/shared/drupalSettings'

const pageView = window?.drupalSettings?.pageView
const isDestinationPage = pageView === DESTINATIONS_PAGE_VIEW

const appendTid = (URLParams) => {
  if (tid && URLParams) {
    URLParams.delete('tid')
    URLParams.append('tid', tid)
  }
  return URLParams
}

const prefetchSearchResults = async (dispatch) => {
  dispatch(toggleGlobalLoader(true))
  const params = new URLSearchParams(window.location.search)
  let paramsString = Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''
  if (isDestinationPage) {
    paramsString =  Array.from(params.entries()).length > 0 ? `?${appendTid(params).toString()}` : ''
  }

  // Main request part
  try {
    let data

    const requestURL = `${SEARCH_ENDPOINT}${paramsString}`
    if (IsDev) {
      data = {}
      console.info(`%c GET ${requestURL} from mock data`, 'color: #67a9ad; font-weight: bold;')
    } else {
      data = pathOr('', ['data'])(await axios.get(requestURL))
    }

    dispatch(toggleGlobalLoader(false))
    return data
  } catch (e) {
    const data = pathOr({}, ['response', 'data'], e)
    dispatch(toggleGlobalLoader(false))
    if (data.message) {
      dispatch(openPopup(GLOBAL_ERROR_POPUP, data))
    }
  }
}

export default (init = false) => (
  dispatch, getState,
) => prefetchSearchResults(dispatch, getState, init)
